import React from "react";
import { Boton } from "./buttonStyle";
import "./button.scss";
import { useNavigate } from "react-router-dom";

const ButtonVolver = ({ destino, clases }) => {
  const navigate = useNavigate();
  return (
    <Boton
      id="btnVolver"
      className={`btn-card rounded bg-danger ${clases}`}
      onClick={() => navigate(`/${destino}`)}
    >
    <i className="fa-solid fa-rotate-left"></i>{" "}Volver{" "}
    </Boton>
  );
};

export default ButtonVolver;
